import React from 'react'
import styled from 'styled-components'

import Contact from './contact/contact'
import Locate from './locate/locate'

const FooterContainer = styled.footer`
  width: 100%;
  background-color: #3c4252;
  ${props => (props.blur ? 'filter: blur(4px)' : '')};
  margin-top: 40px;
`

const Footer = props => {
  const { blur } = props
  return (
    <FooterContainer blur={blur}>
      <Contact {...props} />
      <Locate />
    </FooterContainer>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer/footer.js